export default {"src":"/uk/_next/static/media/actionsIconYellow.d62fe6f0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};